import React, { useEffect, useState } from 'react';
import {
  Bike,
  Dumbbell,
  Hand,
  Laugh,
  Music,
  PartyPopper,
  Scissors,
  Sparkles,
  Stethoscope,
  Trophy,
  UtensilsCrossed,
  Wrench,
} from 'lucide-react';

/**
 * Categories carry an admin-uploaded icon URL, but those uploads go missing
 * often enough (and 500 on some environments) that a broken image would be the
 * default experience. Fall back to a glyph picked from the category name.
 */
const RULES = [
  [/event|party|fest/i, PartyPopper],
  [/music|concert/i, Music],
  [/comedy|standup|stand-up/i, Laugh],
  [/sport|turf|cricket|football/i, Trophy],
  [/gym|fitness/i, Dumbbell],
  [/salon|spa|beauty|makeup/i, Scissors],
  [/doctor|clinic|health|appointment/i, Stethoscope],
  [/plumb/i, Wrench],
  [/clean/i, Sparkles],
  [/car|bike|wash/i, Bike],
  [/food|dine|restaurant|kitchen/i, UtensilsCrossed],
  [/massage|therapy/i, Hand],
];

export const iconForCategory = (name = '') => {
  const match = RULES.find(([pattern]) => pattern.test(name));
  return match ? match[1] : Sparkles;
};

/** Renders the uploaded icon, swapping to the glyph if it fails to load. */
export const CategoryIcon = ({ src, name, className = 'h-12 w-12' }) => {
  const [failed, setFailed] = useState(!src);

  useEffect(() => {
    setFailed(!src);
  }, [src]);

  if (failed) {
    const Glyph = iconForCategory(name);
    return (
      <span className={`flex items-center justify-center ${className}`}>
        <Glyph className="h-2/3 w-2/3 text-ink-700" strokeWidth={1.6} />
      </span>
    );
  }

  return (
    <img
      src={src}
      alt=""
      loading="lazy"
      onError={() => setFailed(true)}
      className={`object-contain drop-shadow-sm ${className}`}
    />
  );
};
